import { createAsyncThunk, createSlice, PayloadAction } from '@reduxjs/toolkit';
import { agencyAPI } from '../../utilities/api';
import { Agency } from '../../utilities/interfaces/Agency';

// represents the shape of the slice in state
interface agencyState {
  agency: Agency | null;
  agencies: Agency[];
  filteredAgencies: Agency[];
}

const initialState: agencyState = {
  agency: null,
  agencies: [],
  filteredAgencies: []
};

const agencySlice = createSlice({
  name: 'stateAgency',
  initialState,
  reducers: {
    // add new Agency item
    addAgencyItem(state, action: PayloadAction<Agency>) {
      // its okay to do this because immer makes it immutable
      state.agencies.push(action.payload);
    },
    clearAgency(state) {
      state.agency = null;
    },
  },
  extraReducers(builder) {
    builder.addCase(getAgencyById.fulfilled, (state, action: any) => {
      state.agency = action.payload;
    });

    builder.addCase(getAllAgencies.fulfilled, (state, action: any) => {
      state.agencies = action.payload;
    });

    builder.addCase(getFilteredAgencies.fulfilled, (state, action: any) => {
      state.filteredAgencies = action.payload;
    });
  },
});

// Async thunk to fetch data from api
// under extra reducers on fulfilled the redux store is updated
export const getAgencyById = createAsyncThunk('stateAgency/getAgencyById', async (id: number) => {
  const response = await agencyAPI.getAgencyByAgencyId(id);
  return response;
});

export const getAllAgencies = createAsyncThunk('stateAgency/getAllAgencies', async () => {
  const response = await agencyAPI.getAllAgencies();
  return response;
});

export const getFilteredAgencies = createAsyncThunk('stateAgency/getFilteredAgencies',async () => {
  const response = await agencyAPI.getFilteredAgencies();
  return response;
});

export const { addAgencyItem, clearAgency } = agencySlice.actions;
export default agencySlice.reducer;
